import { Form, FormFieldType } from "@/forms/Form";

export class UserRoleForm extends Form {
  protected definition = {
    name: { required: true, type: FormFieldType.Text }
  };
}
